module.exports = __webpack_public_path__ + "img/icons-visits_white.f6969168.svg";